import APIV5 from '~/models/api';
import { BaseController } from '~/utils/base-controller';

/**
 * @implements {TextEditor.Node.Definition}
 */
export default class extends BaseController {
	// @ts-ignore
	kid;

	/** @type {string} */
	name;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		super($injector);
		this.name = this.kid;
	}

	async $onInit() {
		const result = await APIV5.instance.repreListSimple({
			items: [this.kid],
			mode:  'simple',
		}, { id: 'text-editor.node.repre' });

		this.$timeout(() => {
			this.name = result.result[this.kid] ?? this.kid;
		});
	}
}
